import React, { Component } from 'react';
import { FullStar, halfstar, emptystar } from '../../../assets/images';
import Skeleton from 'react-loading-skeleton';
import { UserAlert } from '../atoms/alerts';

const getStar = (type) => {
  switch (type) {
    case 'full':
      return FullStar;
    case 'half':
      return halfstar;
    case 'empty':
      return emptystar;
    default:
      return emptystar;
  }
};
const Star = ({ type }) => {
  const star = getStar(type);
  return (
    <div className='w-4 ml-1 h-4 cursor-pointer flex items-center'>
      <img width='13' height='13' src={star} alt='loginsession' />
    </div>
  );
};

class RatingNumber extends React.Component {
  render() {
    const { number } = this.props;

    return <div className='text-gray-700 text-5xl font-semibold text-center'>{number}</div>;
  }
}

class StarRating extends React.Component {
  render() {
    let { rating } = this.props;
    const renderStar = [];
    const rounded = rating - Math.floor(rating);
    let remaining = 5 - Math.ceil(rating);
    rating = Math.floor(rating);
    for (let i = 0; i < rating; i++) {
      renderStar.push(<Star type='full' />);
    }
    if (rounded) renderStar.push(<Star type='half' />);
    while (remaining-- > 0) renderStar.push(<Star type='empty' />);
    return (
      renderStar.map((item, index) => {
        <div className='flex flex-row pl-1 mt-1 justify-center' key={`${item}`+ index}>{item}</div>
      }) 
    )
  }
}

class Text extends Component {
  render() {
    const { styles, children } = this.props;
    return (
      <div className={`max-w-3xl text-center mb-0 text-sm text-gray-500 mt-1 ${styles.join(' ')}`}>{children}</div>
    );
  }
}

class VerticalLine extends Component {
  render() {
    return <div className='border-r border-gray-100 mx-5 h-full'></div>;
  }
}

class ProgressBar extends Component {
  render() {
    const { percentage, starRating } = this.props;
    return (
      <div className='flex flex-row w-full items-center'>
        <div className='grid grid-cols-2 w-1/12 text-gray-700 mr-2 items-center justify-center content-center '>
          <div className='flex justify-center text-gray-700'>{starRating}</div>
          <img src={FullStar} height='10' width='10' alt='star' />
        </div>
        <div className='flex items-center h-2 w-10/12 bg-gray-200 rounded-lg'>
          <span
            style={{ width: `${percentage}%` }}
            className='block overflow-hidden shadow-sm relative rounded-r-md h-full rounded-md bg-green-700 '
          ></span>
        </div>
        <div className='flex items-center w-1/12 ml-3'>
          <Text styles={['text-gray-700']}>{percentage + '%'}</Text>
        </div>
      </div>
    );
  }
}

class RatingCard extends React.Component {
  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }

    if (!this.props.rating) {
      return (
        <div className='bg-white p-5 border border-gray-200 rounded-md w-full h-44'>
          <UserAlert para='Data is not available' paraClasses=' font-semibold text-gray-600' imgClasses=' h-5 w-5' classes=' p-4'/>
        </div>
      );
    }

    const {
      rating,
      number_of_ratings,
      five_star_rating,
      four_star_rating,
      three_star_rating,
      two_star_rating,
      one_star_rating,
    } = this.props;
    return (
      <div className={`flex ` + this.props.classes}>
        <div className='flex flex-row bg-white p-5 border overflow-hidden border-gray-200 rounded-md w-full h-auto items-center'>
          <div className='flex flex-col w-1/4 justify-center'>
            <RatingNumber number={rating} />
            <StarRating rating={rating} />
            <div>
              <Text styles={['text-gray-500']}>{number_of_ratings} ratings</Text>
            </div>
          </div>
          <VerticalLine />
          <div className='flex flex-col w-3/4'>
            <ProgressBar percentage={five_star_rating} starRating={5} />
            <ProgressBar percentage={four_star_rating} starRating={4} />
            <ProgressBar percentage={three_star_rating} starRating={3} />
            <ProgressBar percentage={two_star_rating} starRating={2} />
            <ProgressBar percentage={one_star_rating} starRating={1} />
          </div>
        </div>
      </div>
    );
  }
}

RatingCard.defaultProps = {
  classes: '',
};
export default RatingCard;
